import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import {
  intlShape,
  injectIntl,
  FormattedMessage,
} from '../../util/reactIntl';
import arrayMutators from 'final-form-arrays';
import { propTypes } from '../../util/types';
import { required } from '../../util/validators';
import { Form, Button, FieldSelect, FieldTextInput, FieldCheckboxGroup } from '../../components';

// Create this file using EditListingFeaturesForm.module.css
// as a template.
import css from './EditListingCancelLimitForm.module.css';

export const EditListingCancelLimitFormComponent = props => {

  
  return (

  
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        className,
        disabled,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateError,
        updateInProgress,
        // cancelLimitOptions,
      } = formRenderProps;


      const cancelLimitPlaceholder = intl.formatMessage({
        id: 'EditListingCancelLimitForm.cancelLimitPlaceholder',
      });

      const errorMessage = updateError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingCancelLimitForm.updateFailed" />
        </p>
      ) : null;

      const cancelLimitRequired = required(
        intl.formatMessage({
          id: 'EditListingCancelLimitForm.cancelLimitRequired',
        })
      );

      const checkboxLabel = required(
        intl.formatMessage({
          id: 'EditListingCancelLimitForm.checkboxLabel',
        })
      );

      const cancellationLabel = '';

      const classes = classNames(css.root, className);
      const submitReady = updated && pristine;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;

      const options = [
        {
          "key": "1",
          "label": "Je souhaite que les clients puissent annuler"
        },
        {
            "key": "365",
            "label": "Je ne souhaite pas que les clients puissent annuler"
        },
      ]
      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}

          {/* <FieldSelect
            className={css.capacity}
            name="cancelLimit"
            id="cancelLimit"
            validate={cancelLimitRequired}
          >
            <option value="">{cancelLimitPlaceholder}</option>
            {cancelLimitOptions.map(c => (
              <option key={c.key} value={c.key}>
                {c.label}
              </option>
            ))}
          </FieldSelect> */}


{/* [
    {
        "key": "motocicle",
        "label": "2 roues"
    },
    {
        "key": "hatchBack",
        "label": "Citadine"
    },
    {
        "key": "berlina",
        "label": "Berline"
    },
    {
        "key": "offRoad",
        "label": "4X4"
    },
    {
        "key": "van",
        "label": "Utilitaire"
    }
] */}

          {/* <FieldTextInput
            id="cancelLimit"
            name="cancelLimit"
            className={props.hasCancellationPolicy ? css.capacity : css.capacityDisabled}
            type="number"
            label={cancellationLabel}
            placeholder={cancelLimitPlaceholder}
          /> */}

          <FieldCheckboxGroup className={css.checkboxes} id="cancelLimit" name="cancelLimit" options={options} cancellationLimit={true}/>

          {/* <div className={css.checkboxWrapper}>
          <input type="checkbox" className={css.cancellationCheckbox} defaultChecked={!props.hasCancellationPolicyOneDay || props.cancelLimitIsOneDay} onChange={props.handleCancellationPolicyOneDay}/>
          <div className={css.cancellationLabel}>
            <p>Je souhaite que les clients puissent annuler</p>
            <p>Les annulations seront alors possibles jusqu'à 24h avant le debut de la reservation</p>
          </div>
          </div>


          <div className={css.checkboxWrapper}>
          <input type="checkbox" className={css.cancellationCheckbox} defaultChecked={!props.hasCancellationPolicy || props.cancelLimitIsZero}  onChange={props.handleCancellationPolicy}/>
          <div className={css.cancellationLabel}>
          <FormattedMessage id="EditListingCancelLimitForm.checkboxLabel" />
          </div>
          </div> */}


          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
)};

EditListingCancelLimitFormComponent.defaultProps = {
  selectedPlace: null,
  updateError: null,
};

EditListingCancelLimitFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  updated: bool.isRequired,
  updateError: propTypes.error,
  updateInProgress: bool.isRequired,
  cancelLimitOptions: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ).isRequired,
};

export default compose(injectIntl)(EditListingCancelLimitFormComponent);